import type { CityConfig } from "../city-template/types";

export const merrillvilleConfig: CityConfig = {
  city: "Merrillville",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "merrillville",
  route: "/merrillville",
  title: "Emergency Passport Merrillville, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Merrillville, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Merrillville, Hobart, Crown Point, Schererville, and all Lake County residents. A+ BBB rated registered courier with access to the Chicago Passport Agency, just 40 minutes away.",
  h1: "Emergency & Expedited Passport Services in Merrillville, IN",
  heroSubtitle: "Merrillville travelers — from Lake County professionals and retail district employees to families in Northwest Indiana's most vibrant commercial hub — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, just 40 minutes west via I-65 and the Skyway.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Merrillville%20Indiana%20vibrant%20suburban%20commercial%20district%20with%20modern%20retail%20centers%20and%20Southlake%20Mall%20area%2C%20Northwest%20Indiana%20town%20surrounded%20by%20green%20spaces%20and%20Lake%20County%20landscapes%2C%20professional%20city%20photography%20with%20warm%20golden%20afternoon%20light%2C%20classic%20Midwestern%20suburban%20charm%2C%20clean%20streets%20and%20contemporary%20architecture%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=merrillville-in-hero-001&orientation=landscape",
  heroImageAlt: "Merrillville Indiana commercial district with Lake County suburban charm",
  geoPosition: "41.4828;-87.3328",
  geoPlacename: "Merrillville, Indiana",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604, IL 60605",
    distance: "Approximately 40 minutes west of Merrillville via I-65 and the Chicago Skyway — about 35 miles",
  },
  nearbyCitiesZips: [
    { name: "Merrillville", zips: "46410, 46411" },
    { name: "Hobart", zips: "46342" },
    { name: "Crown Point", zips: "46307" },
    { name: "Schererville", zips: "46375" },
    { name: "Valparaiso", zips: "46383, 46384, 46385" },
    { name: "Portage", zips: "46368" },
    { name: "St. John", zips: "46373" },
    { name: "Lowell", zips: "46356" },
    { name: "Cedar Lake", zips: "46303" },
    { name: "Winfield", zips: "46307" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — only 40 minutes from Merrillville via I-65" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Lake County and Northwest Indiana" },
    { icon: "ri-building-line", title: "NW Indiana's Retail Hub", desc: "Serving Merrillville, Hobart, Crown Point, Schererville, and all Lake County communities" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in the Merrillville commercial corridor" },
  ],
  internalLinks: [
    { name: "Expedited passport in Gary, IN", route: "/gary" },
    { name: "Emergency passport help in Hammond, IN", route: "/hammond-in" },
    { name: "Urgent passport services in Indianapolis, IN", route: "/indianapolis" },
    { name: "Indiana passport services overview", route: "/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604, IL 60605",
  fpcOfficeNote: "Fast Passport Center serves Merrillville, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 35 miles — about 40 minutes via I-65 and the Chicago Skyway. Merrillville's prime location in the heart of Lake County's retail corridor, with direct I-65 access, makes it perfectly positioned for expedited passport service. We handle the Chicago drive so Merrillville residents and Lake County families never need to navigate downtown Chicago traffic.",
  fpcOfficeDistance: "Serving Merrillville, Hobart, Crown Point, Schererville, St. John, Lowell, Cedar Lake, Winfield, and all Lake County communities in Northwest Indiana",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Merrillville and Lake County. From the Southlake Mall corridor and Broadway commercial district to surrounding communities like Hobart, Crown Point, and Schererville — we serve all of Northwest Indiana with direct access to the Chicago Passport Agency.",
  nearbyCitiesIntro: "We serve Merrillville and all nearby communities including Hobart, Crown Point, Schererville, Valparaiso, Portage, St. John, Lowell, Cedar Lake, and Winfield. Merrillville's central Lake County location and immediate I-65 access make it an ideal hub for expedited passport services across Northwest Indiana.",
  howItWorksIntro: "Most Merrillville travelers — especially Lake County business professionals and families — complete everything online and ship documents via overnight courier from any UPS or FedEx in the Merrillville commercial district. Our registered couriers handle the Chicago Passport Agency delivery so you can focus on your travel plans.",
  mistakesIntro: "Merrillville sits at the crossroads of Northwest Indiana with easy access to Chicago — but that convenience can mislead travelers about passport timelines. Here are the most common mistakes we see from Lake County residents.",
  testimonialsIntro: "Merrillville travelers — from Lake County professionals to families in the Southlake corridor to Crown Point and Schererville residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Merrillville, IN? Here are the most common ones we hear from Lake County and Northwest Indiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — only 40 min from Merrillville", "No Chicago drive required — ship from Merrillville", "Perfect for Lake County professionals and families", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned business and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must visit Chicago Passport Agency (~40 min drive)", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Merrillville travelers with immediate departure needs — as fast as 24 hours. Our couriers hand-deliver to the Chicago Passport Agency — only 40 minutes from Merrillville via I-65.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 40-min drive", "Lake County business and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Merrillville adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for Lake County commuters and professionals.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Lake County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Merrillville residents, Lake County families, and new citizens in Northwest Indiana.",
      bullets: ["Acceptance facility scheduling near Merrillville", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Merrillville residents — whether lost at home, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Merrillville and Lake County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Merrillville and Lake County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Merrillville IN", description: "Urgent passport processing for Merrillville Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Merrillville IN", description: "Fast passport renewal for Merrillville Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Merrillville IN", description: "New passport application services for Merrillville Indiana residents and Lake County families." },
    { name: "Child Passport Merrillville IN", description: "Minor passport services for Merrillville Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Kevin M.",
      location: "Merrillville, IN — Near Southlake Mall",
      rating: 5,
      text: "Business trip to London with 5 days notice. Realized my passport had expired during COVID and never renewed it. Fast Passport Center got me sorted in 48 hours. The courier to Chicago made all the difference — I didn't have to deal with Skyway traffic at all.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Maria G.",
      location: "Merrillville, IN — Broadway District",
      rating: 5,
      text: "Family cruise departing from Miami in 8 days and discovered my son's passport was expired. Fast Passport Center walked us through the child renewal process and we had everything in 4 days. Amazing support for Lake County families.",
      service: "Child Passport Renewal",
    },
    {
      name: "David P.",
      location: "Hobart, IN — Near Lake George",
      rating: 5,
      text: "Honeymoon to Italy and my passport had less than 4 months validity. The Merrillville Post Office was booked solid for weeks. Fast Passport Center expedited my renewal and I had it back in 3 days. Saved our honeymoon!",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Jennifer L.",
      location: "Crown Point, IN — Downtown Square",
      rating: 5,
      text: "Lost my passport somewhere during a move from Schererville to Crown Point. Had a flight to Barcelona in 6 days. Fast Passport Center replaced it in 48 hours — the courier service to Chicago was a lifesaver. Never even had to leave Lake County.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "merrillville-in-1",
      name: "Merrillville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "303 W 80th Pl",
      city: "Merrillville",
      state: "IN",
      zip: "46410",
      phone: "(219) 769-4051",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM, Sat: 9:00 AM – 12:00 PM",
      distance: "Central Merrillville, near Broadway and I-65 corridor",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Merrillville acceptance facility. Appointments recommended — call ahead. Saturday hours available for Lake County residents with weekday work commitments.",
      icon: "ri-mail-line",
    },
    {
      id: "merrillville-in-2",
      name: "Crown Point Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "128 S East St",
      city: "Crown Point",
      state: "IN",
      zip: "46307",
      phone: "(219) 663-0319",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 5 miles south of Merrillville, in downtown Crown Point",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative acceptance facility in Crown Point. Convenient for southern Merrillville and Crown Point residents. Historic downtown location near Lake County Courthouse.",
      icon: "ri-mail-line",
    },
    {
      id: "merrillville-in-3",
      name: "Hobart Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "50 S Illinois St",
      city: "Hobart",
      state: "IN",
      zip: "46342",
      phone: "(219) 942-4281",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 5 miles northeast of Merrillville, downtown Hobart",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northeast Lake County facility serving Hobart and eastern Merrillville. Often has better appointment availability than Merrillville during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "merrillville-in-4",
      name: "Schererville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1230 Eagle Ridge Dr",
      city: "Schererville",
      state: "IN",
      zip: "46375",
      phone: "(219) 322-1124",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 5 miles west of Merrillville, in Schererville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "West Lake County facility near the Illinois border. Convenient for Schererville, St. John, and Dyer residents. Good alternative when Merrillville appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "merrillville-in-5",
      name: "Valparaiso Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2700 Valparaiso St",
      city: "Valparaiso",
      state: "IN",
      zip: "46383",
      phone: "(219) 462-4279",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 15 miles east of Merrillville, in Valparaiso",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Porter County facility serving Valparaiso and eastern Lake County. Good option for Merrillville residents willing to drive a bit further for faster appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 40-min drive to Chicago via I-65 & Skyway", fpc: "No — ship from Merrillville, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Lake County Business Travel", agency: "No special support for professionals", fpc: "Experienced with Lake County business travelers" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Merrillville residents often underestimate passport processing times because Chicago is so close. Even though the Chicago Passport Agency is only 40 minutes away, you cannot just show up — appointments are required and booked through NPIC. Routine processing takes 8–11 weeks. Start expedited service at least 6 weeks before travel.",
    },
    {
      icon: "ri-road-map-line",
      title: "Underestimating Chicago Skyway Traffic",
      description: "The Chicago Skyway (I-90) can experience severe congestion during rush hours, major events (Cubs/Sox games, festivals, Lollapalooza), and summer weekends. A 40-minute drive from Merrillville to the Chicago Passport Agency can easily become 90+ minutes. Our courier service eliminates this stress entirely.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Retail photo services at the Southlake Mall area sometimes produce photos that fail Department of State standards. Photos must be exactly 2x2 inches on a white background — no filters, no smiling with teeth showing, no glasses. Photo requirements are strict and non-negotiable.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "First-time passport applicants in Lake County often miss signatures or use the wrong form. DS-11 requires in-person execution at an acceptance facility like the Merrillville Post Office. DS-82 renewal form can be mailed for most adults with previously issued passports.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your planned stay. Lake County business travelers to Europe and Asia frequently discover this requirement too late — especially those with frequent travel schedules who assume their passport is fine.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Factoring in Summer Tourism Season",
      description: "Northwest Indiana sees a spike in passport demand during late spring and early summer as families prepare for summer vacations. Merrillville-area acceptance facilities fill up 3–4 weeks in advance during this period. Book appointments early.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Merrillville or Lake County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in the Merrillville commercial corridor." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Lake County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Chicago Passport Agency — no need to navigate Skyway traffic." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Merrillville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Merrillville, IN?", a: "Fast Passport Center offers emergency passport processing in Merrillville, Indiana in as little as 24–48 hours. Because the Chicago Passport Agency is only 40 minutes away (230 S Dearborn St Suite 380, Chicago IL 60604), our registered couriers can hand-deliver your documents with one of the fastest turnaround times in Indiana." },
    { q: "Does Merrillville have its own passport agency?", a: "No — Merrillville does not have a regional passport agency. The nearest is the Chicago Passport Agency, approximately 35 miles west (about a 40-minute drive via I-65 and the Chicago Skyway). Fast Passport Center's courier service handles the Chicago drive so you don't have to." },
    { q: "Is Merrillville well-positioned for expedited passport service?", a: "Yes, absolutely. Merrillville's location at the intersection of I-65 and US-30 in the heart of Lake County, with direct interstate access to Chicago, makes it one of the best-positioned Northwest Indiana cities for expedited passport service. The Chicago Passport Agency is only 35 miles away." },
    { q: "What airport do Merrillville travelers use?", a: "Most Merrillville travelers use Chicago O'Hare International Airport (ORD), about 55 miles northwest (approximately 1 hour via I-65 and I-294). Chicago Midway (MDW) is also an option at about 45 miles (50 minutes via I-65 and I-55). Both offer extensive international flight options." },
    { q: "How much does an expedited passport cost in Merrillville?", a: "Government fees are fixed: $130 for a first-time adult passport or $130 + $60 expedite fee for a renewed adult passport book. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Merrillville?", a: "Walgreens (multiple Merrillville locations including 700 W 81st Ave), CVS (9120 Connecticut Dr), and the UPS Store (1600 E 80th Ave) all offer passport photos. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Hobart and Crown Point residents?", a: "Yes. Fast Passport Center serves all of Lake County including Merrillville, Hobart, Crown Point, Schererville, St. John, Lowell, Cedar Lake, and Winfield. Our courier service works the same way for everyone throughout the region." },
    { q: "Can I take public transit to the Chicago Passport Agency from Merrillville?", a: "The South Shore Line train connects nearby Gary and Hammond to downtown Chicago's Millennium Station, which is about a 10-minute walk from the Chicago Passport Agency. However, appointments are still required. Fast Passport Center's courier service handles the delivery so you don't need to make the trip at all." },
  ],
  photoLocations: [
    { name: "Walgreens — Merrillville (81st Ave)", address: "700 W 81st Ave, Merrillville, IN 46410", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — Merrillville", address: "9120 Connecticut Dr, Merrillville, IN 46410", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Merrillville", address: "1600 E 80th Ave, Merrillville, IN 46410", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — Hobart", address: "7777 E 37th Ave, Hobart, IN 46342", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Merrillville", address: "5490 Broadway, Merrillville, IN 46410", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Lake County BMV branch on Broadway in Merrillville. Driver's licenses and REAL ID processing. Online reservations recommended — this is a busy branch serving much of central Lake County.", featured: true },
    { name: "Indiana BMV — Crown Point", address: "1180 S Court St, Crown Point, IN 46307", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves Crown Point and southern Lake County. Alternative when Merrillville branch is busy. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "55 miles northwest of Merrillville via I-65 and I-294 — approximately 1 hour",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Primary international airport for Lake County and Northwest Indiana travelers. One of the world's busiest airports with direct flights to destinations across six continents. Major hub for United and American Airlines.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: true,
    },
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "45 miles west of Merrillville via I-65 and I-55 — approximately 50 minutes",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Secondary Chicago airport serving Lake County. Major Southwest Airlines hub with extensive domestic and Caribbean/Mexico routes. Often more convenient for Merrillville travelers than O'Hare.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Lake County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Lake County and all Indiana counties" },
    { label: "Lake County Clerk: Marriage Licenses", url: "https://www.lakecounty.in.gov/", icon: "ri-heart-line", description: "Lake County Clerk — marriage license records for Merrillville and Lake County" },
    { label: "Lake County: Divorce Decrees", url: "https://www.lakecounty.in.gov/", icon: "ri-file-list-3-line", description: "Lake County Clerk of Courts — divorce decree records for Merrillville and Lake County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Merrillville address" },
  ],
};